import axiosInstance from './axios';
 
export const apiGet = (url, config = {}) => axiosInstance.get(url, config);
export const apiPost = (url, data, config = {}) => axiosInstance.post(url, data, config);
export const apiPut = (url, data, config = {}) => axiosInstance.put(url, data, config);
export const apiPatch = (url, data, config = {}) => axiosInstance.patch(url, data, config);
export const apiDelete = (url, config = {}) => axiosInstance.delete(url, config); 